/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import {
  Button,
  Input,
  FormControl,
  FormErrorMessage
} from '@chakra-ui/react'
import Styles from './styles.module.sass'
import { BsPlus } from 'react-icons/bs'
import { HiMinus } from 'react-icons/hi2'

const PeopleInput = ({
  initialStrings = [],
  setValues,
  title,
  error,
  setError
}) => {
  const [inputs, setInputs] = useState(initialStrings)
  const [newInput, setNewInput] = useState('')
  const handleInputChange = (index, value) => {
    const updatedInputs = [...inputs]
    updatedInputs[index] = value
    setInputs(updatedInputs)
  }

  const handleRemoveInput = (index) => {
    const updatedInputs = inputs.filter((_, i) => i !== index)

    setValues && setValues(updatedInputs)
    setInputs(updatedInputs)

    if (setError && updatedInputs.length > 0) {
      setError('')
    }
  }

  const handleAddInput = () => {
    if (newInput.trim() !== '') {
      const currentInputs = [...inputs, newInput]

      setInputs(currentInputs)
      setValues && setValues(currentInputs)
      setNewInput('')

      if (setError) {
        setError('')
      }
    }
  }

  return (
    <FormControl isInvalid={!!error}>
      <div className="max-w-lg">
        <div className={Styles.label}>{ title }</div>
        <div className='space-y-2 mb-4 '>
          {inputs.map((input, index) => (
            <div key={index} className="flex items-center space-x-2">
              <div
                className="bg-white"
              >
                <Input
                  value={input}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                />
              </div>
              <Button
                colorScheme='red'
                onClick={() => handleRemoveInput(index)}
              >
                Remove
              </Button>
            </div>
          ))}
        </div>
        <div className="flex space-x-2">
          <div className="bg-white">
            <Input
              onChange={(e) => setNewInput(e.target.value)}
              value={newInput}
            />
          </div>
          <Button
            onClick={handleAddInput}
          >
            Save
          </Button>
        </div>
        {error && (
          <FormErrorMessage>{error}</FormErrorMessage>
        )}
      </div>
    </FormControl>
  )
}

export default PeopleInput
